module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-pane"
  }, [_c('div', {
    staticClass: "tab-list"
  }, [_vm._l((_vm.tablist), function(item) {
    return _c('div', {
      key: item.name,
      class: ['tab-item', {
        active: item.name === _vm.value
      }]
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('clickTab', item.name)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "current-line",
    style: (_vm.currentLineStyle)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-panes"
  }, [_c('div', {
    staticClass: "panes-list",
    style: (_vm.getCurrentPane)
  }, _vm._l((_vm.tablist), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "panes-item"
    }, [_vm._t(item.name)], 2)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf8ccf84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/index/components/tabs-pane.vue
// module id = 845
// module chunks = 4